// src/App.tsx
import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { SessionProvider } from "./lib/session";
import { FacilityAccessProvider } from "./lib/FacilityAccessContext";
import { NotificationCenterProvider } from "./features/notifications/NotificationCenter";
import { useOfflineConfigPrefetch } from "./features/offline/config/prefetch";
import { useOfflineConfigWarmup } from "./features/offline/config/warmup";
import { OfflineCacheStatusProvider } from "./features/offline/state/OfflineCacheStatusContext";
import { OfflineCachePolicyProvider } from "./features/offline/state/OfflineCachePolicyProvider";
import { OfflineWarmupStatusProvider } from "./features/offline/state/OfflineWarmupStatusContext";
import { OfflineCacheProgressOverlay } from "./features/offline/components/OfflineCacheProgressOverlay";
import { WarmupToast } from "./features/offline/components/WarmupToast";

export default function App() {
  return (
    <SessionProvider>
      <OfflineCachePolicyProvider>
        <OfflineWarmupStatusProvider>
          <OfflineCacheStatusProvider>
            <AppContent />
          </OfflineCacheStatusProvider>
        </OfflineWarmupStatusProvider>
      </OfflineCachePolicyProvider>
    </SessionProvider>
  );
}

function AppContent() {
  useOfflineConfigPrefetch();
  useOfflineConfigWarmup();

  return (
    <FacilityAccessProvider>
      <NotificationCenterProvider>
        <BrowserRouter>
          <AppRoutes />
          <OfflineCacheProgressOverlay />
          <WarmupToast />
        </BrowserRouter>
      </NotificationCenterProvider>
    </FacilityAccessProvider>
  );
}
